/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');

var GetEntityCallReport = require('../services/GetEntityCallReport');
var GetAllSubmitCallReportLookups = require('../../filing-forms/services/GetAllSubmitCallReportLookups');
var DepCallReportEditView = require('../views/DepCallReportEditView');

module.exports = function(entityId, callReportId) {
  NProgress.start();
  NProgress.set(0.4);
  $.when(GetEntityCallReport(callReportId), GetEntityIdentifiers(entityId), GetAllSubmitCallReportLookups())
    .done(function(callReport, entityIdentifiers, quartersLookups) {
      NavUtils.navigate('#dep/entity/' + entityId + '/call-report/' + callReportId + '/edit');

      // callReport.totalAssetsUnderManagement.replace(/\$ /g, '');
      // callReport.totalAssetsUnderManagement = parseFloat(callReport.totalAssetsUnderManagement);
      Scaffold.content.show(
        new DepCallReportEditView({
          viewMode: 'int',
          model: new Backbone.Model({
            entityId: entityId,
            callReportId: callReportId,
            entityIdentifiers: entityIdentifiers,
            callReport: callReport,
            quarters: quartersLookups
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
